module.exports = __webpack_public_path__ + "img/bank_statement.278091b3.png";